export enum Visibility {
    PUBLIC ='PUBLIC', PRIVATE='PRIVATE'
}
